import { useNavigate } from 'react-router-dom'
import { getEventIdWithoutTimestamp } from '../../../../Utils/helpers'

const { Flex, Text, Image, Box } = require('@chakra-ui/react')

const UnvisitedMeeting = ({meeting, index}) => {
  const navigate = useNavigate()
  return (
    <Flex position='relative' mt={index == 0 ? 0 : 2} mb='28px'>
      <Box position='absolute' bg='brandBackground' h='4px' w='full' top='-12px' />
      <Flex
        flexDirection='column'
        border='0.5px solid rgba(28, 28, 28, 0.1)'
        boxShadow='0px 13px 5px rgba(0, 0, 0, 0.01), 0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
        borderRadius='12px'
        bg='white'
        p={5}
        flex='59'
        position='relative'
        overflow='clip'
      >
        <Flex alignItems='center'>
          <Text color='#654F6F' fontWeight='800' fontSize='12px'>
          PREVIOUS  
          </Text>
        </Flex>

        <Flex mt={4} alignItems='center'>
          <Text color='brandTextBlack' fontWeight='700' fontSize='24px'
            cursor='pointer'
            onClick={() => navigate(`/transcripts-summaries/summary?eventId=${meeting.eventId}&tab=HIGH&eventName=${meeting.title}`)}
          >
            {meeting.title}
          </Text>
          {meeting.isRecurring  && (
            <Image cursor='pointer' ml='15px' mt={1} boxSize={4} color='brandTextBlack' src='/assets/icons/recurringEvent.svg'
              onClick={() => {
                navigate(`/transcripts-summaries/dashboard?name=rec_${getEventIdWithoutTimestamp(meeting.eventId)}___${meeting.title.replaceAll(
                  ' ',
                  '-'
                )}`)
              }}
            />
          )}
        </Flex>

        <Flex mt='8px' alignItems='center'>
          <Text
            color='brandTextGrey2'
            flex={1}
            lineHeight='21.6px'
            noOfLines={1}
            wordBreak='break-all'
            cursor='pointer'
            fontSize='14px'
          >
            Bot gone, notes on.
          </Text>
        </Flex>

        <Flex position='absolute'  h='354px' w='354px' right='-176px' bottom='-102px'>
          <Image zIndex={1} position='absolute' bottom='156px' left='102px' boxSize={8} src='/assets/icons/robotPurple.svg' />
          <Box opacity='0.2' position='absolute' top={0} left={0} bg='#D9D9D9' h='354px' w='354px' borderRadius='100%' />
        </Flex>
      </Flex>

      <Flex flex='31' flexDirection='column' ml={2.5} gap={2.5}>
        <Flex
          flexDirection='column'
          border='0.5px solid rgba(28, 28, 28, 0.1)'
          boxShadow='0px 13px 5px rgba(0, 0, 0, 0.01), 0px 7px 4px rgba(0, 0, 0, 0.02), 0px 3px 3px rgba(0, 0, 0, 0.03), 0px 1px 2px rgba(0, 0, 0, 0.04), 0px 0px 0px rgba(0, 0, 0, 0.04)'
          borderRadius='12px'
          bg='white'
          p={5}
          flex={1}
        >
          <Flex alignItems='center'>
            <Text color='#659157' fontWeight='800' fontSize='12px'>
              WHEN
            </Text>
          </Flex>

          <Flex mt={3} alignItems='center'>
            <Text color='brandTextBlack' fontWeight='700' fontSize='24px'>
              {meeting.time}
            </Text>
          </Flex>
          
          <Flex mt='4px'>
            <Text
              color='brandTextGrey2'
              flex={1}
              lineHeight='21.6px'
              noOfLines={1}
              wordBreak='break-all'
            >
              {meeting.meetingDay}
            </Text>
          </Flex>

        </Flex>
      </Flex>

      
    </Flex>
  )
}

export default UnvisitedMeeting